export function formatDow(ts, tz, t, d) {
    const date = new Date(ts * 1000);
    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);

    const isSameDay = (d1, d2) => {
        const format = {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            timeZone: tz
        };
        return d(d1, format) === d(d2, format);
    }

    if (isSameDay(date, today)) {
        return t('home.today');
    } else if (isSameDay(date, tomorrow)) {
        return t('home.tomorrow');
    } else {
        const dayOfWeek = d(date, { weekday: 'long', timeZone: tz });
        const dayOfMonth = d(date, { day: 'numeric', timeZone: tz })
        return `${dayOfWeek} ${dayOfMonth}`;
    }
}

export function formatTemp(v, temperatureUnits) {
    let temperature = v;
    if (temperatureUnits === 'fahrenheit') {
        temperature = (v * 9 / 5) + 32;
    }
    return `${Math.round(temperature)}°`;
}

export function calculateBeaufortForce(speedMps) {
    if (speedMps < 0.3) return 0;
    if (speedMps <= 1.5) return 1;
    if (speedMps <= 3.3) return 2;
    if (speedMps <= 5.4) return 3;
    if (speedMps <= 7.9) return 4;
    if (speedMps <= 10.7) return 5;
    if (speedMps <= 13.8) return 6;
    if (speedMps <= 17.1) return 7;
    if (speedMps <= 20.7) return 8;
    if (speedMps <= 24.4) return 9;
    if (speedMps <= 28.4) return 10;
    if (speedMps <= 32.6) return 11;
    return 12;
}

export function formatSpeed(v, windSpeedUnits) {
    let speed = v;
    let unit = '';

    switch (windSpeedUnits) {
        case 'mph':
            speed = v * 2.23694; // m/s to mph
            unit = 'mph';
            break;
        case 'knots':
            speed = v * 1.94384; // m/s to knots
            unit = 'knots';
            break;
        case 'km/h':
            speed = v * 3.6; // m/s to km/h
            unit = 'km/h';
            break;
        case 'beaufort':
            speed = calculateBeaufortForce(v);
            return `Force ${Math.round(speed)}`;
        case 'm/s':
        default:
            speed = v;
            unit = 'm/s';
            break;
    }
    return `${Math.round(speed)} ${unit}`;
}

export function formatTime(ts, tz) {
    return new Date(ts * 1000).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: tz
    });

}

export function formatPrecipitation(valueInMm, precipitationUnits, t) {
    if (valueInMm === undefined || valueInMm === null) {
        return '';
    }

    let formattedValue;
    switch (precipitationUnits) {
        case 'inches':
            const valueInInches = valueInMm / 25.4;
            if (valueInInches < 1) {
                formattedValue = valueInInches.toFixed(2);
            } else {
                formattedValue = Math.round(valueInInches);
            }
            return t('units.precipitation.in', { value: formattedValue });
        case 'mm':
        default:
            if (valueInMm < 1) {
                formattedValue = valueInMm.toFixed(1);
            } else {
                formattedValue = Math.round(valueInMm);
            }
            return t('units.precipitation.mm', { value: formattedValue });
    }
}

/**
 * Formats a Unix timestamp to a localized datetime string.
 * @param {number} timestamp - Unix timestamp in seconds
 * @param {Object} options - Optional toLocaleString options to override defaults
 * @returns {string} Formatted datetime string
 */
export function formatDateTime(timestamp, options = {}) {
    if (!timestamp) return '';
    const date = new Date(timestamp * 1000);
    return date.toLocaleString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        hourCycle: 'h23',
        month: 'short',
        day: 'numeric',
        ...options
    });
}